if (!customElements.get("amielle-baby-sticky")) {
  customElements.define("amielle-baby-sticky", class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = document.getElementById(this.getAttribute("form"));
      this.target = document.getElementById(this.getAttribute("target"));
      this.footer = document.querySelector("[data-baby-footer]");
      if (!this.form || !this.target) return;
      this.buyPassed = false;
      this.footerVisible = false;
      this.available = !this.querySelector("button").disabled;
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === this.target) this.buyPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.target === this.footer) this.footerVisible = entry.isIntersecting;
        }
        this.update();
      });
      this.observer.observe(this.target);
      if (this.footer) this.observer.observe(this.footer);
      this.form.addEventListener("variant:change", (event) => {
        this.available = Boolean(event.detail.variant?.available);
        this.querySelector("button").disabled = !this.available;
        const sourcePrice = this.form.querySelector("buy-buttons")?.closest("product-rerender")?.querySelector("sale-price");
        if (sourcePrice) {
          const readable = sourcePrice.cloneNode(true);
          readable.querySelectorAll(".sr-only").forEach((node) => node.remove());
          this.querySelector("[data-baby-sticky-price]").textContent = readable.textContent.trim();
        }
        const variantImage = event.detail.variant?.featured_media?.preview_image;
        const image = this.querySelector("img");
        if (image && variantImage?.src) {
          const imageUrl = new URL(variantImage.src, location.origin);
          imageUrl.searchParams.set("width", "120");
          image.src = imageUrl.href;
          image.removeAttribute("srcset");
        }
        this.update();
      }, { signal: this.controller.signal });
    }
    update() {
      this.hidden = !(this.buyPassed && !this.footerVisible && this.available);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}
